import { initializeApp, getApps } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyAb0-Uysgo3eISjXnOK94I5F3ZivAUMSJ0',
  authDomain: 'aayush-kedia-and-company.firebaseapp.com',
  projectId: 'aayush-kedia-and-company',
  storageBucket: 'aayush-kedia-and-company.firebasestorage.app',
  messagingSenderId: '436206165592',
  appId: '1:436206165592:web:6479ec1884c92cbb79342d',
};

const app = getApps().length ? getApps()[0] : initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app);
